export const api = {
  apiUri: process.env.VUE_APP_API_URI || 'https://rickandmortyapi.com/api',
}
